const prefix = "mio_"
export const MioStorage = {
  BIZ: prefix+"biz"
}